module.exports = __webpack_public_path__ + "static/media/s17.4e863b9e.png";